"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Localize = require("../Localization/Localize");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _Timer = _interopRequireDefault(require("./Timer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TIMER_INTERVAL = 60000;

function nextTimer(date) {
  var time = new Date(date).getTime();
  var now = Date.now();
  return time > now ? time : now + TIMER_INTERVAL - (now - time) % TIMER_INTERVAL;
}

function getStateFromProps(_ref) {
  var language = _ref.language,
      value = _ref.value;
  return {
    text: (0, _Localize.localize)('X minutes ago', language, value),
    timer: nextTimer(value)
  };
}

var TimeAgo =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimeAgo, _React$Component);

  function TimeAgo(props) {
    var _this;

    _classCallCheck(this, TimeAgo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeAgo).call(this, props));
    _this.handleInterval = _this.handleInterval.bind(_assertThisInitialized(_this));
    _this.state = getStateFromProps(props);
    return _this;
  }

  _createClass(TimeAgo, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var language = _ref2.language,
          value = _ref2.value;
      this.updateText({
        language: language,
        value: value
      });
    }
  }, {
    key: "handleInterval",
    value: function handleInterval() {
      var _this$props = this.props,
          language = _this$props.language,
          value = _this$props.value;
      this.updateText({
        language: language,
        value: value
      });
    }
  }, {
    key: "updateText",
    value: function updateText(_ref3) {
      var language = _ref3.language,
          value = _ref3.value;
      this.setState(function () {
        return getStateFromProps({
          language: language,
          value: value
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          text = _this$state.text,
          timer = _this$state.timer;
      return _react.default.createElement(_react.default.Fragment, null, text, _react.default.createElement(_Timer.default, {
        at: timer,
        onInterval: this.handleInterval
      }));
    }
  }]);

  return TimeAgo;
}(_react.default.Component);

TimeAgo.propTypes = {
  language: _propTypes.default.string.isRequired,
  value: _propTypes.default.string.isRequired
};

var _default = (0, _connectToWebChat.default)(function (_ref4) {
  var language = _ref4.language;
  return {
    language: language
  };
})(TimeAgo);

exports.default = _default;